package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets7 {
  internal val _27_tehilim_016_txt: AssetResource by lazy { init__27_tehilim_016_txt() }

  internal val _27_tehilim_017_txt: AssetResource by lazy { init__27_tehilim_017_txt() }

  internal val _27_tehilim_018_txt: AssetResource by lazy { init__27_tehilim_018_txt() }

  internal val _27_tehilim_019_txt: AssetResource by lazy { init__27_tehilim_019_txt() }

  internal val _27_tehilim_020_txt: AssetResource by lazy { init__27_tehilim_020_txt() }

  internal val _27_tehilim_021_txt: AssetResource by lazy { init__27_tehilim_021_txt() }

  internal val _27_tehilim_022_txt: AssetResource by lazy { init__27_tehilim_022_txt() }

  internal val _27_tehilim_023_txt: AssetResource by lazy { init__27_tehilim_023_txt() }

  internal val _27_tehilim_024_txt: AssetResource by lazy { init__27_tehilim_024_txt() }

  internal val _27_tehilim_025_txt: AssetResource by lazy { init__27_tehilim_025_txt() }

  internal val _27_tehilim_026_txt: AssetResource by lazy { init__27_tehilim_026_txt() }

  internal val _27_tehilim_027_txt: AssetResource by lazy { init__27_tehilim_027_txt() }

  internal val _27_tehilim_028_txt: AssetResource by lazy { init__27_tehilim_028_txt() }

  internal val _27_tehilim_029_txt: AssetResource by lazy { init__27_tehilim_029_txt() }

  internal val _27_tehilim_030_txt: AssetResource by lazy { init__27_tehilim_030_txt() }

  internal val _27_tehilim_031_txt: AssetResource by lazy { init__27_tehilim_031_txt() }

  internal val _27_tehilim_032_txt: AssetResource by lazy { init__27_tehilim_032_txt() }

  internal val _27_tehilim_033_txt: AssetResource by lazy { init__27_tehilim_033_txt() }

  internal val _27_tehilim_034_txt: AssetResource by lazy { init__27_tehilim_034_txt() }

  internal val _27_tehilim_035_txt: AssetResource by lazy { init__27_tehilim_035_txt() }

  internal val _27_tehilim_036_txt: AssetResource by lazy { init__27_tehilim_036_txt() }

  internal val _27_tehilim_037_txt: AssetResource by lazy { init__27_tehilim_037_txt() }

  internal val _27_tehilim_038_txt: AssetResource by lazy { init__27_tehilim_038_txt() }

  internal val _27_tehilim_039_txt: AssetResource by lazy { init__27_tehilim_039_txt() }

  internal val _27_tehilim_040_txt: AssetResource by lazy { init__27_tehilim_040_txt() }

  internal val _27_tehilim_041_txt: AssetResource by lazy { init__27_tehilim_041_txt() }

  internal val _27_tehilim_042_txt: AssetResource by lazy { init__27_tehilim_042_txt() }

  internal val _27_tehilim_043_txt: AssetResource by lazy { init__27_tehilim_043_txt() }

  internal val _27_tehilim_044_txt: AssetResource by lazy { init__27_tehilim_044_txt() }

  internal val _27_tehilim_045_txt: AssetResource by lazy { init__27_tehilim_045_txt() }

  internal val _27_tehilim_046_txt: AssetResource by lazy { init__27_tehilim_046_txt() }

  internal val _27_tehilim_047_txt: AssetResource by lazy { init__27_tehilim_047_txt() }

  internal val _27_tehilim_048_txt: AssetResource by lazy { init__27_tehilim_048_txt() }

  internal val _27_tehilim_049_txt: AssetResource by lazy { init__27_tehilim_049_txt() }

  internal val _27_tehilim_050_txt: AssetResource by lazy { init__27_tehilim_050_txt() }

  internal val _27_tehilim_051_txt: AssetResource by lazy { init__27_tehilim_051_txt() }

  internal val _27_tehilim_052_txt: AssetResource by lazy { init__27_tehilim_052_txt() }

  internal val _27_tehilim_053_txt: AssetResource by lazy { init__27_tehilim_053_txt() }

  internal val _27_tehilim_054_txt: AssetResource by lazy { init__27_tehilim_054_txt() }

  internal val _27_tehilim_055_txt: AssetResource by lazy { init__27_tehilim_055_txt() }

  internal val _27_tehilim_056_txt: AssetResource by lazy { init__27_tehilim_056_txt() }

  internal val _27_tehilim_057_txt: AssetResource by lazy { init__27_tehilim_057_txt() }

  internal val _27_tehilim_058_txt: AssetResource by lazy { init__27_tehilim_058_txt() }

  internal val _27_tehilim_059_txt: AssetResource by lazy { init__27_tehilim_059_txt() }

  internal val _27_tehilim_060_txt: AssetResource by lazy { init__27_tehilim_060_txt() }

  internal val _27_tehilim_061_txt: AssetResource by lazy { init__27_tehilim_061_txt() }

  internal val _27_tehilim_062_txt: AssetResource by lazy { init__27_tehilim_062_txt() }

  internal val _27_tehilim_063_txt: AssetResource by lazy { init__27_tehilim_063_txt() }

  internal val _27_tehilim_064_txt: AssetResource by lazy { init__27_tehilim_064_txt() }

  internal val _27_tehilim_065_txt: AssetResource by lazy { init__27_tehilim_065_txt() }

  internal fun values(): List<AssetResource> = listOf(_27_tehilim_016_txt, _27_tehilim_017_txt,
      _27_tehilim_018_txt, _27_tehilim_019_txt, _27_tehilim_020_txt, _27_tehilim_021_txt,
      _27_tehilim_022_txt, _27_tehilim_023_txt, _27_tehilim_024_txt, _27_tehilim_025_txt,
      _27_tehilim_026_txt, _27_tehilim_027_txt, _27_tehilim_028_txt, _27_tehilim_029_txt,
      _27_tehilim_030_txt, _27_tehilim_031_txt, _27_tehilim_032_txt, _27_tehilim_033_txt,
      _27_tehilim_034_txt, _27_tehilim_035_txt, _27_tehilim_036_txt, _27_tehilim_037_txt,
      _27_tehilim_038_txt, _27_tehilim_039_txt, _27_tehilim_040_txt, _27_tehilim_041_txt,
      _27_tehilim_042_txt, _27_tehilim_043_txt, _27_tehilim_044_txt, _27_tehilim_045_txt,
      _27_tehilim_046_txt, _27_tehilim_047_txt, _27_tehilim_048_txt, _27_tehilim_049_txt,
      _27_tehilim_050_txt, _27_tehilim_051_txt, _27_tehilim_052_txt, _27_tehilim_053_txt,
      _27_tehilim_054_txt, _27_tehilim_055_txt, _27_tehilim_056_txt, _27_tehilim_057_txt,
      _27_tehilim_058_txt, _27_tehilim_059_txt, _27_tehilim_060_txt, _27_tehilim_061_txt,
      _27_tehilim_062_txt, _27_tehilim_063_txt, _27_tehilim_064_txt, _27_tehilim_065_txt)
}

private fun init__27_tehilim_016_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-016.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-016.txt")

private fun init__27_tehilim_017_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-017.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-017.txt")

private fun init__27_tehilim_018_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-018.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-018.txt")

private fun init__27_tehilim_019_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-019.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-019.txt")

private fun init__27_tehilim_020_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-020.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-020.txt")

private fun init__27_tehilim_021_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-021.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-021.txt")

private fun init__27_tehilim_022_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-022.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-022.txt")

private fun init__27_tehilim_023_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-023.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-023.txt")

private fun init__27_tehilim_024_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-024.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-024.txt")

private fun init__27_tehilim_025_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-025.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-025.txt")

private fun init__27_tehilim_026_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-026.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-026.txt")

private fun init__27_tehilim_027_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-027.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-027.txt")

private fun init__27_tehilim_028_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-028.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-028.txt")

private fun init__27_tehilim_029_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-029.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-029.txt")

private fun init__27_tehilim_030_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-030.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-030.txt")

private fun init__27_tehilim_031_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-031.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-031.txt")

private fun init__27_tehilim_032_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-032.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-032.txt")

private fun init__27_tehilim_033_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-033.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-033.txt")

private fun init__27_tehilim_034_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-034.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-034.txt")

private fun init__27_tehilim_035_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-035.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-035.txt")

private fun init__27_tehilim_036_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-036.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-036.txt")

private fun init__27_tehilim_037_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-037.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-037.txt")

private fun init__27_tehilim_038_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-038.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-038.txt")

private fun init__27_tehilim_039_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-039.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-039.txt")

private fun init__27_tehilim_040_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-040.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-040.txt")

private fun init__27_tehilim_041_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-041.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-041.txt")

private fun init__27_tehilim_042_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-042.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-042.txt")

private fun init__27_tehilim_043_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-043.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-043.txt")

private fun init__27_tehilim_044_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-044.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-044.txt")

private fun init__27_tehilim_045_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-045.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-045.txt")

private fun init__27_tehilim_046_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-046.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-046.txt")

private fun init__27_tehilim_047_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-047.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-047.txt")

private fun init__27_tehilim_048_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-048.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-048.txt")

private fun init__27_tehilim_049_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-049.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-049.txt")

private fun init__27_tehilim_050_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-050.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-050.txt")

private fun init__27_tehilim_051_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-051.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-051.txt")

private fun init__27_tehilim_052_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-052.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-052.txt")

private fun init__27_tehilim_053_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-053.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-053.txt")

private fun init__27_tehilim_054_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-054.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-054.txt")

private fun init__27_tehilim_055_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-055.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-055.txt")

private fun init__27_tehilim_056_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-056.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-056.txt")

private fun init__27_tehilim_057_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-057.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-057.txt")

private fun init__27_tehilim_058_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-058.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-058.txt")

private fun init__27_tehilim_059_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-059.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-059.txt")

private fun init__27_tehilim_060_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-060.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-060.txt")

private fun init__27_tehilim_061_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-061.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-061.txt")

private fun init__27_tehilim_062_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-062.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-062.txt")

private fun init__27_tehilim_063_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-063.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-063.txt")

private fun init__27_tehilim_064_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-064.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-064.txt")

private fun init__27_tehilim_065_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-065.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-065.txt")

public actual val SharedRes.assets.allChapters._27_tehilim_016_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_016_txt

public actual val SharedRes.assets.allChapters._27_tehilim_017_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_017_txt

public actual val SharedRes.assets.allChapters._27_tehilim_018_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_018_txt

public actual val SharedRes.assets.allChapters._27_tehilim_019_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_019_txt

public actual val SharedRes.assets.allChapters._27_tehilim_020_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_020_txt

public actual val SharedRes.assets.allChapters._27_tehilim_021_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_021_txt

public actual val SharedRes.assets.allChapters._27_tehilim_022_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_022_txt

public actual val SharedRes.assets.allChapters._27_tehilim_023_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_023_txt

public actual val SharedRes.assets.allChapters._27_tehilim_024_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_024_txt

public actual val SharedRes.assets.allChapters._27_tehilim_025_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_025_txt

public actual val SharedRes.assets.allChapters._27_tehilim_026_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_026_txt

public actual val SharedRes.assets.allChapters._27_tehilim_027_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_027_txt

public actual val SharedRes.assets.allChapters._27_tehilim_028_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_028_txt

public actual val SharedRes.assets.allChapters._27_tehilim_029_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_029_txt

public actual val SharedRes.assets.allChapters._27_tehilim_030_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_030_txt

public actual val SharedRes.assets.allChapters._27_tehilim_031_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_031_txt

public actual val SharedRes.assets.allChapters._27_tehilim_032_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_032_txt

public actual val SharedRes.assets.allChapters._27_tehilim_033_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_033_txt

public actual val SharedRes.assets.allChapters._27_tehilim_034_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_034_txt

public actual val SharedRes.assets.allChapters._27_tehilim_035_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_035_txt

public actual val SharedRes.assets.allChapters._27_tehilim_036_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_036_txt

public actual val SharedRes.assets.allChapters._27_tehilim_037_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_037_txt

public actual val SharedRes.assets.allChapters._27_tehilim_038_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_038_txt

public actual val SharedRes.assets.allChapters._27_tehilim_039_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_039_txt

public actual val SharedRes.assets.allChapters._27_tehilim_040_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_040_txt

public actual val SharedRes.assets.allChapters._27_tehilim_041_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_041_txt

public actual val SharedRes.assets.allChapters._27_tehilim_042_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_042_txt

public actual val SharedRes.assets.allChapters._27_tehilim_043_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_043_txt

public actual val SharedRes.assets.allChapters._27_tehilim_044_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_044_txt

public actual val SharedRes.assets.allChapters._27_tehilim_045_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_045_txt

public actual val SharedRes.assets.allChapters._27_tehilim_046_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_046_txt

public actual val SharedRes.assets.allChapters._27_tehilim_047_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_047_txt

public actual val SharedRes.assets.allChapters._27_tehilim_048_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_048_txt

public actual val SharedRes.assets.allChapters._27_tehilim_049_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_049_txt

public actual val SharedRes.assets.allChapters._27_tehilim_050_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_050_txt

public actual val SharedRes.assets.allChapters._27_tehilim_051_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_051_txt

public actual val SharedRes.assets.allChapters._27_tehilim_052_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_052_txt

public actual val SharedRes.assets.allChapters._27_tehilim_053_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_053_txt

public actual val SharedRes.assets.allChapters._27_tehilim_054_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_054_txt

public actual val SharedRes.assets.allChapters._27_tehilim_055_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_055_txt

public actual val SharedRes.assets.allChapters._27_tehilim_056_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_056_txt

public actual val SharedRes.assets.allChapters._27_tehilim_057_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_057_txt

public actual val SharedRes.assets.allChapters._27_tehilim_058_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_058_txt

public actual val SharedRes.assets.allChapters._27_tehilim_059_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_059_txt

public actual val SharedRes.assets.allChapters._27_tehilim_060_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_060_txt

public actual val SharedRes.assets.allChapters._27_tehilim_061_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_061_txt

public actual val SharedRes.assets.allChapters._27_tehilim_062_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_062_txt

public actual val SharedRes.assets.allChapters._27_tehilim_063_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_063_txt

public actual val SharedRes.assets.allChapters._27_tehilim_064_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_064_txt

public actual val SharedRes.assets.allChapters._27_tehilim_065_txt: AssetResource
  get() = CommonMainAssets7._27_tehilim_065_txt
